import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { LockKey, Eye, EyeSlash, WarningCircle } from 'phosphor-react';

import {
  VALIDATE_EMAIL_TOKEN,
  startCreatePasswordPage,
  validateEmailToken,
  resetPassword,
} from 'redux/actions/pages';
import { removeMessage } from 'redux/actions/message';
import MessageTypes from 'enums/message-types';
import AuthShell from './home-components/AuthShell';
import FormField from './home-components/FormField';
import CustomAlert from './CustomAlert';
import CustomLoading from './CustomLoading';

const CreatePassword = ({
  redirectTo,
  message,
  startCreatePasswordPage,
  validateEmailToken,
  resetPassword,
  removeMessage,
  localizations,
}) => {
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const location = useLocation();
  const history = useHistory();

  const token = new URLSearchParams(location.search).get('token');
  const passwordsDiffer = password2 !== '' && password !== password2;

  useEffect(() => {
    startCreatePasswordPage();
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (redirectTo && redirectTo !== '' && redirectTo !== '/create-password') {
      history.push(redirectTo);
    }
    // eslint-disable-next-line
  }, [redirectTo]);

  useEffect(() => {
    if (token && token !== '') {
      validateEmailToken({ token });
    }
    // eslint-disable-next-line
  }, [location.search]);

  useEffect(() => {
    if (
      message &&
      message.messageContent !== undefined &&
      message.messageContent !== null &&
      message.messageContent !== ''
    ) {
      Swal.fire({
        icon: message.messageType || 'error',
        title:
          message.messageType === MessageTypes.success
            ? localizations?.MESSAGE_SUCCESS
            : localizations?.MESSAGE_ERROR,
        text: message.messageContent,
        showCancelButton: false,
        confirmButtonText: localizations?.MESSAGE_GO_HOME_CONFIRM_BTN,
        confirmButtonColor: '#174b87',
      }).then((_) => {
        removeMessage(VALIDATE_EMAIL_TOKEN);
        history.push('/signin');
      });
    }
    // eslint-disable-next-line
  }, [message]);

  const onResetPasswordClick = (e) => {
    e.preventDefault();

    if (token) {
      resetPassword({ password, password2, token });
    } else {
      console.log('Token yok!');
    }
  };

  const passwordType = showPassword ? 'text' : 'password';

  return (
    <>
      <CustomAlert />
      <CustomLoading />
      <AuthShell
        path="/create-password"
        asideTitle="Güçlü bir şifre için"
        aside={
          <ul className="op-auth__points">
            <li>
              <span aria-hidden="true">🔤</span>
              Harfleri ve rakamları birlikte kullan.
            </li>
            <li>
              <span aria-hidden="true">🙈</span>
              Başka sitelerde kullandığın bir şifreyi seçme.
            </li>
            <li>
              <span aria-hidden="true">🤫</span>
              Şifreni kimseyle paylaşma; yalnızca sen bil.
            </li>
          </ul>
        }
      >
        <span className="op-kicker">Yeni şifre</span>
        <h1>Yeni şifreni belirle</h1>
        <p className="op-auth__lead">
          Yeni şifreni iki kez yaz; kaydettikten sonra bu şifreyle giriş
          yapabilirsin.
        </p>
        {token ? null : (
          <p className="op-auth__notice" role="alert">
            <WarningCircle size={22} weight="fill" aria-hidden="true" />
            <span>
              Şifre oluşturma bağlantısı eksik ya da hatalı görünüyor.{' '}
              <a href="/forgot-password">Yeni bağlantı iste</a>
            </span>
          </p>
        )}
        <form className="op-auth__form" method="post" onSubmit={onResetPasswordClick}>
          <FormField id="new-password" label="Yeni şifre" icon={LockKey}>
            <input
              id="new-password"
              type={passwordType}
              name="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="op-auth__reveal"
              aria-label={showPassword ? 'Şifreleri gizle' : 'Şifreleri göster'}
              aria-pressed={showPassword}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
            </button>
          </FormField>
          <FormField id="new-password2" label="Yeni şifre (tekrar)" icon={LockKey}>
            <input
              id="new-password2"
              type={passwordType}
              name="password2"
              autoComplete="new-password"
              aria-invalid={passwordsDiffer}
              aria-describedby="new-password2-hint"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
            />
          </FormField>
          <p
            id="new-password2-hint"
            className={`op-auth__hint-inline${passwordsDiffer ? ' op-auth__hint-inline--error' : ''}`}
            aria-live="polite"
          >
            {passwordsDiffer ? 'Şifreler eşleşmiyor.' : ''}
          </p>
          <button className="op-btn op-btn--primary op-btn--lg op-auth__submit" type="submit">
            Şifremi Kaydet
          </button>
        </form>
        <p className="op-auth__foot">
          <a href="/signin">← Giriş ekranına dön</a>
        </p>
      </AuthShell>
    </>
  );
};

const mapStateToProps = (state) => ({
  redirectTo: state.ui.redirectTo,
  message: state.message[VALIDATE_EMAIL_TOKEN],
  localizations: state.localization?.pairs,
});

const mapDispatchToProps = {
  startCreatePasswordPage,
  validateEmailToken,
  resetPassword,
  removeMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreatePassword);
